import { JobGetResponse } from "@/types/job";
import { CreateFastshotResult } from "@/utils/api/screenshot-service/fastshot";
import { getCombinedJobHistory } from "@/utils/job";

export const defaultCropDimensions = "218, 84, 1005, 586";

export interface JobCreatorConfig {
  crop_dimensions?: string;
  description?: string;
  email?: string;
  image_uncropped?: string;
  image_uncropped_height?: number;
  image_uncropped_width?: number;
  interval?: string;
  keyword_action?: string;
  keywords?: string;
  mode?: string;
  notification_threshold?: number;
  proxy_id?: number;
  trigger?: string;
  url?: string;
  wait_time?: number;
  xpath?: string;
}

interface ToJobCreatorConfigFromJobOptions {
  job: JobGetResponse;
}

export const toJobCreatorConfigFromJob = ({ job }: ToJobCreatorConfigFromJobOptions): JobCreatorConfig | undefined => {
  const combinedJobHistory = getCombinedJobHistory({
    job,
  }).filter((item) => {
    return item.history !== undefined && item.history.error_log_id === undefined;
  });

  const historyItem = combinedJobHistory[0];

  if (historyItem) {
    return {
      crop_dimensions: historyItem.history?.crop_dimensions,
      description: job.description,
      image_uncropped: historyItem.history?.image_uncropped,
      image_uncropped_height: historyItem.history?.image_uncropped_height,
      image_uncropped_width: historyItem.history?.image_uncropped_width,
      keyword_action: job.keyword_action,
      keywords: job.keywords,
      mode: job.mode,
      notification_threshold: job.notification_threshold,
      proxy_id: job.proxy_id,
      trigger: String(job.notification_threshold),
      url: job.url,
      wait_time: job.wait_time,
      xpath: job.xpath,
    };
  } else {
    return undefined;
  }
};

interface ToJobCreatorConfigFromFastshotOptions {
  response: CreateFastshotResult;
}

export const toJobCreatorConfigFromFastshot = ({
  response,
}: ToJobCreatorConfigFromFastshotOptions): JobCreatorConfig => {
  return {
    description: response.title,
    image_uncropped: response.image,
    image_uncropped_height: response.height,
    image_uncropped_width: response.width,
  };
};
